import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import Backend from 'i18next-http-backend';

import { LANGUAGE_LOCALSTORAGE_KEY } from '@/shared/constants/localstorage';

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        returnNull: false,
        fallbackLng: 'en',
        defaultNS: 'translation',
        ns: [
            'translation',
            'affiliate',
            'onboarding',
            'auth',
            'subscription',
            'dashboard',
            'pattern-studio',
            'table',
            'pattern',
            'pattern-watchlist',
            'data-display',
            'profile-management',
            'trading-journal-connection',
            'trading-journal',
        ],
        preload: ['en', 'it'],
        backend: {
            loadPath:
                '/locales/{{lng}}/{{ns}}.json?v=1.50.13-ai-disclosure-short',
            allowMultiLoading: false,
            crossDomain: false,
        },
        interpolation: {
            escapeValue: false,
        },
        lng: localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY) ?? 'en',
        load: 'languageOnly',
    });

export default i18n;
